import React from 'react'
import Navbar from '../components/Navbar'
import data from '../data/garlik.json'
import ProductCard from '../components/ProductCard'
import Footer from '../components/Footer'

const Garlik = () => {
    return (
        <>
            <Navbar />
            <section className="mrg_tb">
                <div className="container">

                    <div className="heading d-flex flex-column justify-content-center align-items-center mb-4">
                        <h2 className="Viga text-center  wow animate__flash" data-wow-duration="1s">Garlic Products
                        <span className="cl-theme"></span></h2>
                    </div>

                    <div className="row">
                        {
                            data?.map(item => {
                                return <ProductCard data={item} type="garlic" />
                            })
                        }
                    </div>
                </div>
            </section>
            <Footer></Footer>
        </>
    )
}

export default Garlik